// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3acdT","Label":"Input_Label__Sd2aE","InputElement":"Input_InputElement__1JPrc"};